import React from "react"
import { ContentBar } from "./content-bar"
import { ImageBar } from "./image-bar"

export const HelloBar = ({
  campaign,
  promoType = "content",
}: {
  campaign: string
  promoType?: "content" | "image"
}) => {
  return (
    <div className="w-full xl:h-14 h-20 fixed top-navbar z-[100] lg:mt-1 2xl:mt-1.5">
      {promoType === "content" ? (
        <ContentBar campaign={campaign} />
      ) : (
        <ImageBar campaign={campaign} />
      )}
    </div>
  )
}
